
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-alignment.html
riot.tag2('menu-button-alignment',
  '<svg class="bulk-actions-menu-item_icon"> <use xlink:href="#align-center-icon"></use> </svg> <svg class="bulk-actions-menu-item_arrow"> <use xlink:href="#caret-menu-icon"></use> </svg>',
  '',
  'class="bulk-actions-menu-item" data-tip="Align items" onclick="{toggleAlignmentPanel}"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

this.toggleAlignmentPanel = function (e) {
  e.stopPropagation();
  if (canvas.nodeAlignmentPanelTag.isOpen && canvas.nodeAlignmentPanelTag.fromOrigin(_this.parent.menuName)) {
    _this.root.removeAttribute('data-tip-hide');
    canvas.nodeAlignmentPanelTag.hide();
    _this.parent.unsetActiveTool(_this.root);

    _eventTracking2.default.track({
      category: 'Toolbar',
      action: 'Close-Align-Menu',
      label: 'Align'
    });
  } else {
    canvas.hidePopups();
    _this.parent.resetTools();
    _this.root.setAttribute('data-tip-hide', 'true');
    _this.parent.setActiveTool(_this.root);
    canvas.nodeAlignmentPanelTag.summon({
      referenceEl: _this.root,
      origin: _this.parent.menuName
    });

    _eventTracking2.default.track({
      category: 'Toolbar',
      action: 'Open-Align-Menu',
      label: 'Align'
    });
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-alignment')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-alignment.html
// module id = 731
// module chunks = 0